import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'

export const createSchema = Yup.object().shape({
  nome: Yup.string().required(mensagemPadrao),
  cargaHoraria: Yup.string().required(mensagemPadrao)
})
